module.exports = __webpack_public_path__ + "img/zhengzhou_center.f7821ab7.jpg";